import { Classification, DepartmentCode } from 'types';
import { generateQueryString } from '../strings/shared-helpers-strings';
import { externalDeliveryDownloadListDetailService } from '@services/private/operation-history/external-delivery/download-list-detail.service';
import { is200xRange } from '@utils/utilities';
import { updateState } from '../update-state';

type ListDataType = {
  page: number;
  size: number;
  sortName: string;
  sortType: string;
  schGroup: string;
  schKeyword: string;
  adminConfigEnv: {
    cssJsVersion: string;
  } | null;
  shmHistDownloadList:
    | [
        {
          fileTotalCnt: number;
          fileTotalSize: number;
          histDt: string;
          histSeq: string;
          remoteIp: string;
          shmDeptCd: DepartmentCode;
          shmLfsKind: Classification;
          shmSubject: string;
        },
      ]
    | [];
  totalCount: number;
};

export const getExternalDeliveryDownloadList = async (
  listData: ListDataType,
  payload = [],
  stateSetter,
  fields,
) => {
  const { page, size, sortName, sortType, schGroup, schKeyword } = listData;

  const queryString = generateQueryString(
    [
      { key: 'page', value: page },
      { key: 'size', value: size },
      { key: 'sortName', value: sortName },
      { key: 'sortType', value: sortType },
      { key: 'schGroup', value: schGroup },
      { key: 'schKeyword', value: schKeyword },
    ].map((item) => {
      return fields.includes(item.key)
        ? payload.find((field) => {
            // @ts-ignore
            return field.key === item.key;
          })
        : item;
    }),
  );

  const { response, statusCode } =
    await externalDeliveryDownloadListDetailService(queryString);

  if (response?.code === '1' && is200xRange(statusCode)) {
    const list = [
      { key: 'adminConfigEnv', value: response?.result?.adminConfigEnv },
      {
        key: 'shmHistDownloadList',
        value: response?.result?.shmHistDownloadInfo?.shmHistDownloadList,
      },
      {
        key: 'totalCount',
        value: response?.result?.shmHistDownloadInfo?.totalCount,
      },
    ];

    payload.forEach((item) => {
      list.push(item);
    });

    updateState(list, stateSetter);
  }
};
